import React, {useRef, useEffect, useContext} from 'react'
import {ReducerContext} from './Provider'
import Statuses from './Statuses'
import base from './patterns/base'
import SystemLogger from '../SystemLogger'
import './localStyles.css'

export default function FileUploader(props) {
  const {
      submit, 
      helperMessage: Message, 
      parentID, 
      setlogoToState, 
      customName = null, 
      multiple = true,
      disabled, 
      buttonClassName = '', 
      buttonStyle = {}, 
      boxStyle, 
      boxClassName,
      pre = [], 
      post = []
  } = props 

  const {state, dispatch} = useContext(ReducerContext)

  const dndRef = useRef(null)

  const logger = new SystemLogger({})

  useEffect(function () {
    // invariable checking
    if (!props.pattern && !submit)
      throw new Error('no pattern or submit prop supplied; uploading files will do nothing')
    if (!parentID) {
      // console.log('file uploader does not know where to upload to')
    }

    dispatch({type: 'pattern', value: props.pattern})
  }, [])

  useEffect(
    function () {
      if (Object.keys(state.photos).length && submit) {
        submit(state.photos)
      }
    },
    [state.photos]
  )

  useEffect(
    function () {
      if (!state.files.length) return
      if (!state.pattern && !submit) return
      ;(async function () {
        try {
          if (state.pattern) {
            console.log('Uploading files using pattern...',state.pattern)
            //DOE1-537-REOPEN
            await base(state, dispatch, state.pattern(parentID, state, dispatch), setlogoToState, customName)
            dispatch({type: 'uploading', value: false})
            return
          }

          await submit(state.files, (statuses) => dispatch({type: 'statuses', value: statuses}))
        } catch (e) {
          console.log(e)
        } finally {
          if (post.length)
            for (let f of post) {
              f()
            }
          dispatch({type: 'loading', value: false})
        }
      })()
    },
    [state.files]
  )

  function dragover(e) {
    e.preventDefault()
    dispatch({type: 'hovering', value: true})
  }

  function dragleave(e) {
    e.preventDefault()
    dispatch({type: 'hovering', value: false})
  }

  async function drop(e) {
    e.preventDefault()
    dispatch({type: 'uploading', value: true})

    let files = []
    if (e.dataTransfer) {
      files = e.dataTransfer.items
        ? Array.from(e.dataTransfer.items)
            .filter((i) => i.kind === `file`)
            .map((f) => f.getAsFile())
        : Array.from(e.dataTransfer.files)
    } else {
      files = Array.from(e.target.files)
      dndRef.current.value = null
    }

    const allowedExtensions = ['.png', '.bmp', '.jpeg', '.jpg'];
    files = files.filter((file) => {
      const extension = file.name.toLowerCase().match(/\.[^.]+$/);
      return extension && allowedExtensions.includes(extension[0]);
    });

    if (!files.length) {
      console.warn(`No valid files dropped`)
      dispatch({type: 'uploading', value: false})
      logger.log(`No valid files dropped`)
      return
    }

    if (!multiple && files.length > 1) {
      files = [files[0]]; 
    }

    if (e.dataTransfer) {
      if (e.dataTransfer.items) e.dataTransfer.items.clear()
      else e.dataTransfer.clearData()
    }

    if (pre.length)
      for (let f of pre) {
        f(files)
      }
    dispatch({type: 'files', value: files})
  }

  return (
    <ReducerContext.Provider value={{state, dispatch}}>
      <div
        className={`flex-column full-height full-width align-center justify-center file-uploader ${
          state.hovering && `dragover`
        }`}
        style={disabled || state.uploading ? {pointerEvents: 'none', opacity: '0.4'} : {}}
      >
        <div
          className={`files full-height full-width align-center justify-center flex-column margin-1 ${boxClassName}`}
          style={{flex: 1, backgroundColor: '#E9ECEF', color: 'black', padding: `5rem`, ...boxStyle}}
          onDrop={drop}
          onDragOver={dragover}
          onDragLeave={dragleave}
        >
          {!state.uploading && (
            <div style={{fontSize: `150%`, width: `100%`}}>
              <Message />
            </div>
          )}
          {state.uploading && <Statuses statuses={state.statuses} uploaded={state.uploadedCount} total={state.files.length} />}
        </div>
        
        {/*  Added overflow styling to the container */}
        <div className="upload-button" style={{ maxWidth: '100%', overflow: 'hidden', padding: '10px' }}>
          <p>Or...</p>
          <input
            // Merged maxWidth: 100% with buttonStyle to ensure it shrinks
            style={{ maxWidth: '100%', ...buttonStyle }}
            className={`${buttonClassName}`}
            type="file"
            onChange={(e) => drop(e)}
            multiple={multiple}
            ref={dndRef}
            accept="image/png,image/bmp,image/jpeg,image/jpg"
          />
        </div>
      </div>
    </ReducerContext.Provider>
  )
}